module.exports = __webpack_public_path__ + "img/1.979f9ac7.png";